function isValidPathComponent(component: string) {
    let hasNonWhitespace = false;
    let hasNonDot = false;

    for (let ii = 0; ii < component.length; ++ii) {
        const ch = component[ii];

        if (component.charCodeAt(ii) < 0x20 || ch === '\\' || ch === '/' || ch === '\"' || ch === '<' || ch === '>' || ch === '|' || ch === ':' || ch === '*' || ch === '?') {
            return false;
        }

        if (ch.trim().length > 0) {
            hasNonWhitespace = true;
        }

        if (ch != '.') {
            hasNonDot = true;
        }
    }

    return hasNonWhitespace && hasNonDot;
}

const filenameAndExtensionRe = /^(.+)(\.[^\.]+)$/s;

export function getFilenameExtension(fn: string) {
    const match = filenameAndExtensionRe.exec(fn);
    if (match) {
        return match[2];
    }
}

export function getFilenameAndExtension(fn: string) {
    const match = filenameAndExtensionRe.exec(fn);
    if (match) {
        return { filename: match[1], extension: match[2] };
    }
}

export enum FileValidationResult {
    Valid = 0,
    EmptyName = 1,
    InvalidCharacter = 2,
    InvalidExtension = 3,
    Duplicate = 4,
    TooLarge = 5
}

export function isValidFileNameWithoutExtension(name: string) {
    if (!name) return false;
    return isValidPathComponent(name);
}

export function validateFilePath(path: string, validExtensions: Set<string>) {
    if (path.length === 0) {
        return FileValidationResult.EmptyName;
    }
    
    const parts = path.split('/');

    for (let part of parts) {
        if (!isValidPathComponent(part)) {
            return FileValidationResult.InvalidCharacter;
        }
    }

    const lcext = getFilenameExtension(parts[parts.length - 1])?.toLowerCase();
    if (lcext == null || !validExtensions.has(lcext)) {
        return FileValidationResult.InvalidExtension;
    }

    return FileValidationResult.Valid;
}

export function createValidFilename(filename: string) {
    const parts = getFilenameAndExtension(filename);
    if (!parts) {
        return;
    }

    if (isValidFileNameWithoutExtension(parts.filename)) {
        return filename;
    }

    let result = '';
    for (let ii=0; ii<parts.filename.length; ++ii) {
        const ch = parts.filename[ii];
        if (parts.filename.charCodeAt(ii) < 0x20 || ch === '\\' || ch === '/' || ch === '\"' || ch === '<' || ch === '>' || ch === '|' || ch === ':' || ch === '*' || ch === '?') {
            result = result + '_';
        } else {
            result = result + ch;
        }
    }
    return result + parts.extension;
}